import { render, staticRenderFns } from "./AppPagamentos.vue?vue&type=template&id=a48934d8&"
import script from "./AppPagamentos.vue?vue&type=script&lang=js&"
export * from "./AppPagamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports